import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton, Popover, Link } from '@mui/material';
import { ENV } from '../../../config/config';
import api from '../../../config/axios-instance';

export default function AccountPopover() {
    const userProfileData = useSelector((state) => state.UserProfileData);
    const navigate = useNavigate();
    const token = JSON.parse(localStorage.getItem('clientToken'));
    const clientId = JSON.parse(localStorage.getItem('clientId'));
    const [open, setOpen] = useState(null);
    const [teacherProfileData, setTeacherProfileData] = useState();

    async function fetchData() {
        try {
            const response = await api.get(`${ENV.appBaseUrl}/teacher/profile`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            if (response?.data?.success) {
                setTeacherProfileData(response?.data?.teacher);
             } else {
                toast.error(response?.data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    useEffect(() => {
       fetchData();
    }, []);
    const MENU_OPTIONS = [
        {
            label: 'Account',
        },
    ];
    const handleOpen = (event) => {
        setOpen(event.currentTarget);
    };

    const handleClose = () => {
        setOpen(null);
    };

    const handleLogout = async () => {

        try {
            const response = await api.post(`${ENV.appBaseUrl}/auth/logout/${clientId}`);
            if (response.data.success) {
                setOpen(null);
                localStorage.removeItem('clientToken');
                localStorage.removeItem('client');
                localStorage.removeItem('clientId');
                navigate('/login');
            } else {
                setOpen(null);
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.removeItem('userId');
                navigate('/login');
            }
        } catch (error) {
            toast.error(error?.message);
        }
    };

    return (
        <>
            <IconButton onClick={handleOpen} sx={{p: 0,border: '1px solid #34A595',}}>
                <Avatar
                    src={userProfileData?.teacher?.profileImage
                        ? `${ENV.file_Url}/${userProfileData?.teacher?.profileImage}`
                        : `${ENV.file_Url}/${teacherProfileData?.profileImage}`}
                />
            </IconButton>
            <Popover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        p: 0,
                        mt: 1.5,
                        ml: 0.75,
                        width: 200,
                        '& .MuiMenuItem-root': {
                            typography: 'body2',
                            borderRadius: 0.75,
                        },
                    },
                }}
            >
                <Box sx={{ my: 1.5, px: 2.5 }}>
                    <Typography variant="subtitle2" noWrap>
                        {teacherProfileData?.name}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                        {teacherProfileData?.email}
                    </Typography>
                </Box>
                <Divider sx={{ borderStyle: 'dashed' }} />
                <Stack sx={{ p: 1 }}>
                    <MenuItem sx={{padding: '0'}} onClick={() => handleClose()}>
                        {/* {teacherProfileData && teacherProfileData?.administrator ? <Link href='/account' className="popover-link">Account</Link> : <Link href='/profile' className="popover-link">Profile</Link> } */}
                        {teacherProfileData?.administrator && !teacherProfileData?.instantSignup 
                            ? <Link href='/account' className="popover-link">Account</Link> 
                            : (teacherProfileData?.administrator  && teacherProfileData?.instantSignup ) 
                            ? <Link href='/profile' className="popover-link">Profile</Link> 
                            : <Link href='/profile' className="popover-link">Profile</Link>
                        }
                    </MenuItem>
                </Stack>
                <Divider sx={{ borderStyle: 'dashed' }} />
                <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
                    Logout
                </MenuItem>
            </Popover>
        </>
    );
}
